import { connect } from 'react-redux';
import SalesReportContainer from './index';

const connector = connect();

export default connector(SalesReportContainer);
